/**
 * Expose jQuery on window before any legacy plugin loads.
 * Legacy plugins check typeof jQuery at module init time.
 *
 * Do NOT alias `jquery` to this file — CJS plugins use require('jquery')
 * and would receive { default: fn } instead of the real jQuery object.
 */
import jQueryImport from 'jquery';

const jQuery = jQueryImport?.default ?? jQueryImport;

window.jQuery = window.$ = jQuery;

export default jQuery;
